// Abre un PDF que se descarga con la sesión del ERP. La pestaña se abre en
// el mismo clic (antes de esperar la descarga) para que el navegador no la
// bloquee como ventana emergente; luego se le carga el PDF.
export async function abrirPdf(descargar) {
  const pestana = window.open('', '_blank');
  if (pestana) {
    pestana.opener = null;
    pestana.document.title = 'Cargando PDF…';
    pestana.document.body.innerHTML = '<p style="font-family:sans-serif;color:#6b7280;padding:2rem">Cargando PDF…</p>';
  }
  try {
    const blob = await descargar();
    const url = URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
    if (pestana) {
      pestana.location.href = url;
    } else {
      // Sin pestana (bloqueada): se descarga el archivo en vez de sacar al usuario del SPA.
      const enlace = document.createElement('a');
      enlace.href = url;
      enlace.download = 'documento.pdf';
      enlace.click();
    }
    // La pestana puede seguir abierta y recargar el blob: se revoca mucho despues.
    setTimeout(() => URL.revokeObjectURL(url), 10 * 60 * 1000);
  } catch (err) {
    if (pestana) pestana.close();
    throw err;
  }
}
